export const servicesData = [
    {
        id: 1,
        title: "Design",
        image: "https://dev254.kodesolution.com/edigitaal/wp-content/uploads/2025/10/service-1.png",
        description: "Creative Design and Development"
    },
    {
        id: 2,
        title: "Development",
        image: "https://dev254.kodesolution.com/edigitaal/wp-content/uploads/2025/10/service-2.png",
        description: "Innovative Tech Solutions"
    },
    {
        id: 3,
        title: "Marketing",
        image: "https://dev254.kodesolution.com/edigitaal/wp-content/uploads/2025/10/service-1.png",
        description: "Digital Marketing Strategies"
    },
    {
        id: 4,
        title: "SEO",
        image: "https://dev254.kodesolution.com/edigitaal/wp-content/uploads/2025/10/service-2.png",
        description: "Search Engine Optimization"
    },
];


export const valuesData = [
    {
        title: "Client-Centric Growth",
        description:
            "Understanding business goals deeply to deliver  measurable results."
    },
    {
        title: "Data-Driven Decisions",
        description:
            "Leveraging analytics and insights to build smarter, high-impact digital strategies."
    },
    {
        title: "Technology & Innovation",
        description:
            "Using modern technology to create scalable, future-ready digital solutions."
    },
    {
        title: "Sustainable Digital Success",
        description:
            "Driving long-term growth through performance, security, and efficiency."
    },
    // {
    //     title: "Our Mission",
    //     description:
    //         "Our mission is to empower businesses with strategy, technology, and measurable digital growth."
    // }
];



export const servicesData_Two = [
    {
        id: 1,
        title: "Design",
        image: "https://dev254.kodesolution.com/edigitaal/wp-content/uploads/2025/10/service-1.png",
        description: "Creative Design and Development",
        description2: "We craft visually stunning and user-friendly designs that enhance brand identity. Our creative team focuses on modern UI/UX principles to deliver impactful digital experiences."
    },
    {
        id: 2,
        title: "Development",
        image: "https://dev254.kodesolution.com/edigitaal/wp-content/uploads/2025/10/service-2.png",
        description: "Innovative Tech Solutions",
        description2: "We build scalable and high-performance web and mobile applications using modern technologies. Our development process ensures security, speed, and reliability."
    },
    {
        id: 3,
        title: "Marketing",
        image: "https://dev254.kodesolution.com/edigitaal/wp-content/uploads/2025/10/service-1.png",
        description: "Digital Marketing Strategies",
        description2: "Our marketing strategies help businesses grow online through targeted campaigns. We focus on brand awareness, audience engagement, and measurable results."
    },
    {
        id: 4,
        title: "SEO",
        image: "https://dev254.kodesolution.com/edigitaal/wp-content/uploads/2025/10/service-2.png",
        description: "Search Engine Optimization",
        description2: "We optimize websites to rank higher on search engines and increase organic traffic. Our SEO approach includes keyword research, on-page optimization, and performance tracking."
    }
];
// export default valuesData;
